import React, { useMemo, PropsWithChildren } from 'react';
/**
 * RTL for emotion
 */
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import stylisRtl from 'stylis-rtl';
import { isSSR } from '@front10/utils';

interface Props {
  direction: 'ltr' | 'rtl';
}

const EmotionCache = (props: PropsWithChildren<Props>) => {
  const { children } = props;
  if (isSSR()) {
    return <>{children} </>;
  }
  return <Cache {...props} />;
};

const Cache = ({ children, direction }: PropsWithChildren<Props>) => {
  const createCacheFn = useMemo(() => {
    if (direction === 'ltr') {
      return createCache({ key: direction });
    }
    return createCache({ key: direction, stylisPlugins: [stylisRtl] });
  }, [direction]);

  return (
    <CacheProvider key={direction} value={createCacheFn}>
      {children}
    </CacheProvider>
  );
};

export { EmotionCache };
